module.exports = __webpack_public_path__ + "landing_static/img/69.9810292e.png";